// extracted by css-extract-rspack-plugin
export default {"wrapper":"VrCampaignBuilderPage-module__wrapper--Yfn0N"};